import { cva } from "class-variance-authority";

export const sidebarIconVariants = cva(
  "[--fill1:var(--sidebar-icon-fill-1)] [--fill2:var(--sidebar-icon-fill-2)] [--fill3:var(--sidebar-icon-fill-3)] [--fill4:var(--sidebar-icon-fill-4)] hover:[--fill1:var(--sidebar-icon-fill-1-hover)] hover:[--fill2:var(--sidebar-icon-fill-2-hover)] hover:[--fill3:var(--sidebar-icon-fill-3-hover)] hover:[--fill4:var(--sidebar-icon-fill-4-hover)]",
  {
    variants: {
      isActive: {
        true: "[--fill1:var(--sidebar-icon-fill-1-hover)] [--fill2:var(--sidebar-icon-fill-2-hover)] [--fill3:var(--sidebar-icon-fill-3-hover)] [--fill4:var(--sidebar-icon-fill-4-hover)]",
      },
    },
  },
);

// NOTE: Single-ink variant for the main sidebar's outline nav glyphs. Kept
// separate because the admin sidebar still renders duotone icons through
// sidebarIconVariants above.
export const sidebarNavIconVariants = cva(
  "[--fill1:var(--sidebar-nav-icon)] hover:[--fill1:var(--sidebar-nav-icon-active)]",
  {
    variants: {
      isActive: {
        true: "[--fill1:var(--sidebar-nav-icon-active)] [--nav-glyph-bold:0.5]",
      },
    },
  },
);
